<template>
  <BModalForm
    ref="modal"
    v-bind="$attrs"
    :create-default-data="createDefaultData"
    max-width="600px"
    @closed="$emit('closed')"
  >
    <template #title-text="{ editable, form }">
      {{ getTitle(editable, form) }}
    </template>

    <template #default="{ editable, form, onSaveContinue }">
      <RoadmapBaseEventsForm
        :form="form"
        :disabled="editable"
        @save-continue="onSaveContinue"
      />

      <RoadmapBaseEventCriteriaList
        v-if="form.id"
        :event-id="form.id"
      />

      <RoadmapBaseEventFilesList
        v-if="form.id"
        v-model="form.base_event_files"
        :roadmap-id="roadmap_id"
        :direction-id="direction_id"
        :event-id="form.id"
        @created="onSaveContinue"
      />
    </template>
  </BModalForm>
</template>

<script>
import { RoadmapBaseEventModel as Model } from '../Model'

import BModalForm from '@/components/modals/BModalForm.vue'
import RoadmapBaseEventsForm, { createDefaultData } from './RoadmapBaseEventsForm.vue'
import RoadmapBaseEventFilesList from '../BaseEventFiles/RoadmapBaseEventFilesList.vue'
import RoadmapBaseEventCriteriaList from '../BaseEventCriteria/RoadmapBaseEventCriteriaList.vue'


export default {
  name: 'RoadmapBaseEventsModal',
  components: {
    BModalForm,
    RoadmapBaseEventsForm,
    RoadmapBaseEventFilesList,
    RoadmapBaseEventCriteriaList,
  },
  inheritAttrs: false,
  props: {
    roadmap_id: {
      type: [Number, String],
      required: true,
    },
    direction_id: {
      type: [Number, String],
      required: true,
    },
  },
  data: () => ({
    createDefaultData,
  }),
  methods: {
    open() {
      return this.$refs.modal.open()
    },
    close() {
      return this.$refs.modal.close()
    },
    getTitle(editable, form) {
      if (editable) return Model.page_title.view(form)
      return form.id ? Model.page_title.edit : Model.page_title.create
    },
  },
}
</script>
